import { render } from "./ChannelTable.vue?vue&type=template&id=4ae63502"
import script from "./ChannelTable.vue?vue&type=script&lang=js"
export * from "./ChannelTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__